/**
 * Pure helpers for secure-upload identity preflight UI.
 */

export function formatStoreList(stores) {
  if (!stores || !stores.length) return '';
  return stores.map((s) => `#${s}`).join(', ');
}

export function isConfirmationRequiredPoll(responseData) {
  return responseData?.status === 'confirmation_required';
}

export function rosterGapInstructions(instructions) {
  if (!Array.isArray(instructions)) return [];
  return instructions.filter((item) => item?.gap_type === 'LOCATION_ROSTER_GAP');
}
